import {
    POST_FILES_DELIVERY_POINT_LOADING,
    POST_FILES_DELIVERY_POINT_SUCCESS,
    POST_FILES_DELIVERY_POINT_REJECT,
    POST_FILES_DELIVERY_POINT_RESET,
} from "../../actions/filesDeliveryPoint/post";

import {
    DELETE_FILES_DELIVERY_POINT_LOADING,
    DELETE_FILES_DELIVERY_POINT_SUCCESS,
    DELETE_FILES_DELIVERY_POINT_REJECT,
    DELETE_FILES_DELIVERY_POINT_RESET,
} from "../../actions/filesDeliveryPoint/delete";

const stateInit = {
    isLoading: false,
    isSuccess: false,
    isReject: false,
    error: {},
    data: [],
    detail: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    post: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    },
    delete: {
        isLoading: false,
        isSuccess: false,
        isReject: false,
        error: {},
        data: {},
    }
}

const fileDeliveryPointReducer = (state = stateInit, action) => {
    switch (action.type) {

        // ------------- POST --------------------
        case POST_FILES_DELIVERY_POINT_LOADING: return {
            ...state,
            post: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case POST_FILES_DELIVERY_POINT_SUCCESS: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case POST_FILES_DELIVERY_POINT_REJECT: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case POST_FILES_DELIVERY_POINT_RESET: return {
            ...state,
            post: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        // ------------- DELETE --------------------
        case DELETE_FILES_DELIVERY_POINT_LOADING: return {
            ...state,
            delete: {
                isLoading: true,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }
        case DELETE_FILES_DELIVERY_POINT_SUCCESS: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: true,
                isReject: false,
                error: {},
                ...action.payload,
            }
        }
        case DELETE_FILES_DELIVERY_POINT_REJECT: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: false,
                isReject: true,
                data: {},
                error: action.payload?.response?.data
            }
        }
        case DELETE_FILES_DELIVERY_POINT_RESET: return {
            ...state,
            delete: {
                isLoading: false,
                isSuccess: false,
                isReject: false,
                data: {},
                error: {},
            }
        }

        default: return state;
    }
}

export default fileDeliveryPointReducer